module.exports = __webpack_public_path__ + "public/img/zuiyoujiazhi.d4eceac6.png";